module.exports = __webpack_public_path__ + "media/customer.7468892d.mp4";